module.exports = __webpack_public_path__ + "static/media/5_7.85ab5446.png";